<template>
  <create-account-layout
    :current-step="3"
    title="Request Access"
  >
    <form
      novalidate="novalidate"
      @submit.prevent="handleSubmit"
    >
      <p class="my-3 text-left text-dark-gray">
        For you to be able to join this carrier, we need an authorized
        representative of the carrier to grant you access.
      </p>
      <p class="mb-6 text-left text-dark-gray">
        A request will be emailed to the contact methods publicly registered
        with the FMCSA or to any users already belonging to this account.
      </p>
      <!-- <div>
        <h5 class="pl-2 mt-3 text-left text-2xs font-bold uppercase w-full"> 
          Recipients of Request
        </h5>
        
        <div v-if="filteredContacts?.length > 0">
          <div
            v-for="(contact, index) in filteredContacts"
            :key="index"
            class="text-left pl-2 mb-4 pt-4"
            :class="{'border-t-2 border-light-gray': index > 0}"
          >
            <div v-if="claimedCarrier && (contact?.masked_email || contact?.masked_phone)">
              <p v-if="contact?.masked_email" class="text-body-color">{{ contact?.masked_email }}</p>
            </div>
            <div v-else-if="contact?.value">
              <p class="text-body-color">{{ contact?.value }}</p>
            </div>
            <div v-else>
              <p class="text-body-color">{{ contact?.value }}</p>
            </div>
          </div>
        </div> -->
      <!-- <div class="mt-3" v-else>
          <div class="w-full h-9 rounded-md loading-gradient"></div>
        </div> -->

      <button-main
        class="mt-3"
        :disabled="buttonDisabled"
        type="submit"
        :loading-spinner="isLoading"
        value="Request Access"
      />
      <button-main
        variant="secondary"
        class="mb-3 mt-3"
        @click="onGoBack()"
      >
        Go Back
      </button-main>

      <!-- </div> -->
    </form>
  </create-account-layout>
</template>

<script>
import CreateAccountLayout from '@/components/layouts/CreateAccountLayout.vue';
import ButtonMain from '@/components/Button.vue';
import { toastResponse } from '@/common/handleServerResponse';

//Mixin
import fmcsaContacs from '@/mixins/fmcsaContacs';

export default {
  name: 'RequestAccessFMSCA',
  components: {
    CreateAccountLayout,
    ButtonMain,
  },
  mixins: [fmcsaContacs],
  data() {
    return {
      isLoading: false,
      claimedCarrier: true,
      emails: [],
    };
  },
  computed: {
    // censusEmails: function(){
    //   return this.emails?.filter(item => item?.is_type === "census" || item?.is_type === "census_cell" || item?.is_type === "census_main");
    // },
    // filteredContacts: function(){
    //   let masked = this.contacts?.filter(contact => contact?.masked_email && contact?.masked_phone )?.length > 0;
    //   if (masked?.length > 0) {
    //     return masked;
    //   } else if (this.contacts?.length > 0) {
    //     return this.contacts;
    //   } else {
    //     return [];
    //   }
    // },
    buttonDisabled() {
      return false;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch('users/refreshCurrentUser');

      const { requested_carrier_id } =
        this.$store.state.users?.currentUser || {};

      const carrier = await this.$store.dispatch(
        'carriers/getCarrierById',
        requested_carrier_id
      );
      const emails = await carrier?.data?.email_addresses;
      this.emails = emails;
      // let currentUser = this.$store.state.users.currentUser;
      // Redirect if the user doesn't have a email or name.
      // if (!currentUser.email || !currentUser.first_name) {
      //   console.log('either no email or first name for user');
      //   console.log('email: '+currentUser.email);
      //   console.log('first_name: '+currentUser.first_name);
      //   // this.$router.push({name: 'RequestAccessFMSCA'});
      // } else {
      const findInput = document.querySelector('#full_name');
      if (findInput) {
        setTimeout(() => {
          findInput.focus();
        }, 0);
      }
      // this.getContacts();
      // }
    } catch (error) {
      console.error('ERROR:', error);
      this.$router.push({ name: 'RequestAccess' });
    }
  },
  methods: {
    onGoBack() {
      this.$router?.go(-1);
    },
    async getContacts() {
      const contactsData = this.$store.state.carriers?.maskedContacts;
      this.getEmailFMCSAContacts();
      if (contactsData?.length < 1) {
        this.claimedCarrier = false;
        // this.contacts = contactsData;
      }
    },
    async handleSubmit() {
      this.isLoading = true;
      const requestAccessRes = await this.$store.dispatch(
        'users/carrierAskToBeAdded',
        {
          carrier_id: this.$store.state.users.currentUser.requested_carrier_id,
        }
      );

      if ([200, 201].includes(requestAccessRes.status)) {
        // send user to account success screen
        this.$router.push({
          name: 'AccessPending',
        });
      } else {
        toastResponse(this, requestAccessRes, null);
      }
      this.isLoading = false;
    },
  },
};
</script>

<style>
.radio-class {
  @apply border-white;
}
.radio-class > label {
  @apply rounded-md bg-white;
}

.radio-class > label > .checkmark {
  @apply bg-off-white;
}
</style>
